/**
 * Strips HTML tags from a string for plain-text display.
 */
export function stripHtml(html: string | null | undefined): string {
  if (!html || typeof html !== "string") return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").trim();
}

/**
 * Extracts a plain image URL from a string that may be:
 * - A plain URL (e.g. "https://example.com/image.png")
 * - HTML with img tag (e.g. '<img src="https://..." />')
 */
export function extractImageUrl(value: string | null | undefined): string {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  // If it looks like HTML (contains <img and src=), extract the URL
  if (trimmed.includes("<img") && trimmed.includes("src=")) {
    const match = trimmed.match(/src\s*=\s*["']([^"']+)["']/i);
    return match ? match[1].trim() : trimmed;
  }
  return trimmed;
}

